import {
  AnalyticsRestService,
  AppReviewRestService,
  ClaimsRestService,
  DeveloperRestService,
  DispatchService,
  GorgiasService,
  IdentityService,
  MarketplaceRestService,
  MetadataService,
  MerchantService,
  MacrosService,
  BillingRestService,
  PlatformsService,
  OrdersRestService,
  ImplementationRestService,
  FiltersRestService,
  CustomizationRestService,
  PostmarkRestService,
  SubscriptionsService,
} from '~/support/services';

export default function useGateway() {
  const baseUrl = useRuntimeConfig().public.gatewayBaseUrl as string;

  const analytics = new AnalyticsRestService(baseUrl);
  const appReview = new AppReviewRestService(baseUrl);
  const developer = new DeveloperRestService(baseUrl);
  const dispatch = new DispatchService(baseUrl);
  const identity = new IdentityService(baseUrl);
  const marketplace = new MarketplaceRestService(baseUrl);
  const merchant = new MerchantService(baseUrl);
  const claims = new ClaimsRestService(baseUrl);
  const metadata = new MetadataService(baseUrl);
  const macros = new MacrosService(baseUrl);
  const billing = new BillingRestService(baseUrl);
  const platforms = new PlatformsService(baseUrl);
  const orders = new OrdersRestService(baseUrl);
  const implementation = new ImplementationRestService(baseUrl);
  const filters = new FiltersRestService(baseUrl);
  const customization = new CustomizationRestService(baseUrl);
  const postmark = new PostmarkRestService(baseUrl);
  const subscriptions = new SubscriptionsService(baseUrl);
  const gorgias = new GorgiasService(baseUrl);

  return {
    analytics,
    appReview,
    billing,
    claims,
    customization,
    developer,
    dispatch,
    filters,
    gorgias,
    identity,
    implementation,
    macros,
    marketplace,
    merchant,
    metadata,
    orders,
    platforms,
    postmark,
    subscriptions,
  };
}
